module.exports = __webpack_public_path__ + "img/00525563001760.2de62e55.png";